.editor {
  :global(.ProseMirror) {
    height: 100%;
    padding: 0.5rem;
    border: 0.5px solid var(--theme-border-primary-default);
    border-radius: var(--mantine-radius-default);
    outline: none;
    font-size: var(--mantine-font-size-sm);
    background-color: var(--mantine-color-white);
    color: var(--mantine-color-gray-8);

    &:focus {
      border-color: var(--theme-border-primary-hover);
    }

    p {
      margin-top: 0;
    }

    :global(.mention) {
      font-weight: 500;
      text-decoration: underline;
    }

    a {
      cursor: pointer;
    }

    /* Softer, Linear-style diff treatment: insertions get a subtle tinted
       pill rather than a loud underline, deletions just mute and
       strike through rather than a red highlight. */
    :global([data-suggestion-insertion]) {
      color: var(--mantine-color-indigo-8);
      background-color: var(--mantine-color-indigo-0);
      border-radius: 3px;
      box-shadow: inset 0 0 0 1px var(--mantine-color-indigo-2);
      text-decoration: none;
    }

    :global([data-suggestion-deletion]) {
      color: var(--mantine-color-gray-5);
      text-decoration: line-through;
      text-decoration-color: var(--mantine-color-gray-4);
      background-color: transparent;
    }
  }
}

.placeholder {
  &::before {
    display: block;
    opacity: 0;
    transition: opacity 150ms ease-in-out;
    content: attr(data-empty-text);
    pointer-events: none;
    height: 0;
    color: var(--mantine-color-gray-5);
  }
}

.editor :global(.ProseMirror)[contenteditable='true'] {
  .placeholder {
    :global(.ProseMirror-focused) &::before,
    &:nth-child(1)::before,
    &:nth-child(2)::before {
      opacity: 1;
    }
  }
}

.editor :global(.ProseMirror)[contenteditable='false'] {
  padding: 0;
  border: none;

  p:last-of-type {
    margin-bottom: 0;
  }
}
